import { GET_LOCAL_PRICE, GetLocalPricePayload } from "../types/currency";

export const getLocalPrice = (payload: GetLocalPricePayload): any => {
  return { type: GET_LOCAL_PRICE, payload };
};
